const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"45dddd68d9fb4213b8ca4d3b4f59cc3991ee7bec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"45dddd68d9fb4213b8ca4d3b4f59cc3991ee7bec"};
      